// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertyLocationMap = require("../../common/Property/PropertyLocationMap.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardRelayPreviewLocation_localDraft_graphql = require("../../../__generated__/PropertyWizardRelayPreviewLocation_localDraft_graphql.bs.js");
let PropertyWizardRelayPreviewLocation_displayHelpers_graphql = require("../../../__generated__/PropertyWizardRelayPreviewLocation_displayHelpers_graphql.bs.js");

let convertFragment = PropertyWizardRelayPreviewLocation_displayHelpers_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewLocation_displayHelpers_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewLocation_displayHelpers_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewLocation_displayHelpers_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewLocation_displayHelpers_graphql.node, convertFragment, fRef);
}

let DisplayHelpersFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardRelayPreviewLocation_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewLocation_localDraft_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewLocation_localDraft_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewLocation_localDraft_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewLocation_localDraft_graphql.node, convertFragment$1, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__Preview__Location(props) {
  let displayHelpers = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewLocation_displayHelpers_graphql.node, convertFragment, props.displayHelpers);
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewLocation_localDraft_graphql.node, convertFragment$1, props.draft);
  let location = Stdlib_Option.getOr(draft.draftProperty.hideAddress, false) ? Stdlib_Option.map(displayHelpers.hiddenPropertyLocation, x => x.fragmentRefs) : Stdlib_Option.map(displayHelpers.propertyLocation, x => x.fragmentRefs);
  if (location !== undefined) {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("h2", {
          children: "Location",
          className: "text-2xl font-medium text-gray-800"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(PropertyLocationMap.FromPropertyLocation.make, {
            propertyLocation: Primitive_option.valFromOption(location)
          }),
          className: "my-6"
        })
      ]
    });
  } else {
    return null;
  }
}

let MissingFieldMarker;

let Validators;

let make = PropertyWizardRelay__Preview__Location;

exports.MissingFieldMarker = MissingFieldMarker;
exports.Validators = Validators;
exports.DisplayHelpersFragment = DisplayHelpersFragment;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
